module.exports = __webpack_public_path__ + "img/note.9aab0bf8.svg";